import { render, staticRenderFns } from "./Appendice.vue?vue&type=template&id=2d9c2dbe&scoped=true&"
import script from "./Appendice.vue?vue&type=script&lang=js&"
export * from "./Appendice.vue?vue&type=script&lang=js&"
import style0 from "./Appendice.vue?vue&type=style&index=0&id=2d9c2dbe&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d9c2dbe",
  null
  
)

export default component.exports